// extracted by mini-css-extract-plugin
module.exports = {"container":"_2AN1J","small":"ka2u6","triangle":"_1AjXS","top":"kXixJ"};